import { DeleteOutlined } from '@ant-design/icons'
import { Button, message, Upload, UploadProps } from 'antd'
import React, { FC } from 'react'

type FileItem = {
    name: string;
    type: string;
    content: string;
    uid: string;
    size: any
};
type PropsAtt = {
    items: any[]
    onChangeValue: (val: any) => void
    setFileList: (val: any) => void
    fileList: any
    selectedValue: any;
}
export const CombinedAttachmentUpload: FC<PropsAtt> = (props) => {

    const getBase64 = (file: File): Promise<string> =>

        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (err) => reject(err);
        });


    const MAX_SIZE_MB = 2;
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

    const propsAd = (categoryID: any): UploadProps => ({
        beforeUpload: (file) => {
            if (file.size > MAX_SIZE_BYTES) {
                message.error(`${`File size should be less than ${MAX_SIZE_MB} MB`}`)
                return Upload.LIST_IGNORE;
            }

            getBase64(file).then((dataUrl: string) => {
                const base64 = dataUrl.split(",")[1] || "";
                const formatted: any = {
                    name: file.name,
                    type: file.type,
                    content: base64,
                    uid: file.uid || crypto.randomUUID(),
                    size: file.size,
                    category_id: categoryID
                };

                props.setFileList((prev: FileItem[]) => [...prev, formatted]);
            });

            return false;
        },

        onRemove: (file) => {
            props.setFileList((prev: FileItem[]) =>
                prev.filter((f) => f.uid !== file.uid)
            );
        },

        showUploadList: false,
    });

    const formatFileSize = (bytes: number) => {
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    };
    const removeFile = (categoryId: any) => {
        props.setFileList((prev: any[]) => {
            return prev.filter(f => f.category_id !== categoryId);
        });
    };
    return (
        <div>
            <h4 style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                Upload Document
                {!!props.items.filter((e) => e.mandatory).length ?
                    <span style={{ color: "#9C1D26", fontSize: "12px" }}>*</span>
                    : <span></span>}
            </h4>

            <div style={{ paddingTop: "0px", color: "#33333399", paddingBottom: "20px" }}>
                Supports JPG, PNG, PDF  .  Upto 2 MB
            </div>

            {props.items.map((e, i) => {
                return (
                    <div>
                        <div key={i} style={{
                            display: "flex",
                            padding: "5px 0px"
                        }}>
                            <div style={{
                                flex: 1,
                            }}>
                                {e.label}
                            </div>
                            <div>
                                {(() => {
                                    let file = props.fileList.find((el: any) => el.category_id == e.value)
                                    return !!file ?
                                        <div style={{
                                            display: "flex",
                                            alignItems: "center",
                                        }}>
                                            <span style={{ padding: "5px", display: "inline-block", paddingRight: "10px" }}>{file.name}</span>
                                            <Button onClick={() => {
                                                removeFile(e.value)
                                            }}>
                                                <DeleteOutlined />
                                            </Button>
                                        </div> : <Upload
                                            {...propsAd(e.value)}
                                            fileList={props.fileList as any}
                                            accept=".pdf,.png,.jpg,.jpeg"
                                            multiple
                                        >
                                            <Button style={{ width: "270px" }} >Click to Upload</Button>
                                        </Upload>
                                })()}
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    );
};





